import React, { useState, useEffect, useRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import './Compromisos.css';

const Identidad = () => {
  const [flippedCards, setFlippedCards] = useState({});
  const haloRef = useRef(null);

  const toggleCard = (cardId) => {
    setFlippedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (haloRef.current) {
        haloRef.current.style.left = `${e.clientX}px`;
        haloRef.current.style.top = `${e.clientY}px`;
      }
    };
    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const mainImages = [
    { src: '/images/fotos/Gestion/gestion_1.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_2.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_3.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_4.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_5.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_6.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_7.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_8.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_9.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_10.jpeg', alt: 'Rever_foto' },
    { src: '/images/fotos/Gestion/gestion_11.jpeg', alt: 'Rever_foto' },
  ];

  const carouselOptions = {
    type: 'loop',
    perPage: 1,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    resetProgress: false,
    height: '500px',
    speed: 1200,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
  };

  const valuesData = [
    {
      id: 'Gestión Integral de Calidad',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 100 100"  >
    <path d="M28.5 68.5v-34h-1.6a4.89 4.89 0 0 0-4.8 4.9v35.4a4.89 4.89 0 0 0 4.8 4.9h35.6a4.89 4.89 0 0 0 4.8-4.9v-1.4h-34a4.89 4.89 0 0 1-4.8-4.9ZM46.4 30.2h17.7a1.58 1.58 0 0 0 1.6-1.6v-3.3a4.89 4.89 0 0 0-4.8-4.9H49.6a4.82 4.82 0 0 0-4.8 4.9v3.3a1.64 1.64 0 0 0 1.6 1.6Z" />
    <path d="M73 24.4h-1.6a.74.74 0 0 0-.8.8v3.3a6.57 6.57 0 0 1-6.5 6.6H46.4a6.64 6.64 0 0 1-6.5-6.6v-3.3a.74.74 0 0 0-.8-.8h-1.6a4.82 4.82 0 0 0-4.8 4.9v35.3a4.89 4.89 0 0 0 4.8 4.9H73a4.82 4.82 0 0 0 4.8-4.9V29.4a4.85 4.85 0 0 0-4.8-5ZM60.9 55.5a1.58 1.58 0 0 1-1.6 1.6H43.1a1.58 1.58 0 0 1-1.6-1.6v-1.6a1.58 1.58 0 0 1 1.6-1.6h16.2a1.58 1.58 0 0 1 1.6 1.6Zm8.1-8.2a1.58 1.58 0 0 1-1.6 1.6H43.1a1.58 1.58 0 0 1-1.6-1.6v-1.6a1.58 1.58 0 0 1 1.6-1.6h24.3a1.58 1.58 0 0 1 1.6 1.6Z" />
  </svg>
      ),
      title: 'Gestión Integral de Calidad',
      subtitle: 'Planificación de calidad, ITPs, procedimientos, puntos hold/witness y control documental.',
      details: [
        'Planificación de calidad desde el inicio del proyecto',
        'Elaboración y seguimiento de ITPs (Inspection and Test Plans)',
        'Redacción y control de procedimientos técnicos',
        'Gestión de puntos hold y witness con el cliente',
        'Control documental riguroso y trazable',
      ],
    },
    {
      id: 'Cumplimiento de Normativas Internacionales',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF4729"
    stroke="#F8CF4729"
    viewBox="0 0 17 17"
  >
    <path
      fill="#F8CF4799"
      d="M8.516 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5S13.202 0 8.516 0zM1.041 9h2.937c.044 1.024.211 2.031.513 3H1.888a7.426 7.426 0 0 1-.847-3zm2.937-1H1.041a7.426 7.426 0 0 1 .847-3h2.6a11.76 11.76 0 0 0-.51 3zm1.569-3h5.896c.33.965.522 1.972.569 3H4.978c.046-1.028.239-2.035.569-3zm-.569 4h7.035a10.82 10.82 0 0 1-.572 3H5.55a10.783 10.783 0 0 1-.572-3zm8.035 0h2.978a7.426 7.426 0 0 1-.847 3H12.5c.302-.969.469-1.976.513-3zm0-1a11.76 11.76 0 0 0-.51-3h2.641c.48.906.775 1.923.847 3h-2.978zm1.489-4h-2.354a12.19 12.19 0 0 0-1.55-2.7A7.52 7.52 0 0 1 14.502 4zM9.074 1.028c.824.897 1.484 1.9 1.972 2.972H5.944a11.3 11.3 0 0 1 1.97-2.97c.199-.015.398-.03.602-.03.188 0 .373.015.558.028zm-2.691.285A12.163 12.163 0 0 0 4.843 4H2.529a7.518 7.518 0 0 1 3.854-2.687zM2.529 13h2.317c.391.951.915 1.851 1.547 2.689A7.51 7.51 0 0 1 2.529 13zm5.397 2.97A11.355 11.355 0 0 1 5.948 13h5.094a11.328 11.328 0 0 1-1.979 2.972c-.181.013-.363.028-.547.028-.2 0-.395-.015-.59-.03zm2.661-.267A12.176 12.176 0 0 0 12.144 13h2.358a7.518 7.518 0 0 1-3.915 2.703z"
    />
  </svg>
      ),
      title: 'Normativas Internacionales',
      subtitle: 'Alineado a códigos y estándares aplicables según el alcance del proyecto, incluyendo ASME, API, AWS, ASTM, GRI, AISC, ACI, IEC/NFPA/IEEE, especificaciones del cliente y requerimientos del fabricante.',
      details: [
        'ASME – Recipientes a presión, tuberías y soldadura',
        'API – Estándares para la industria Oil & Gas',
        'AWS – Calificación de soldadores y procedimientos de soldadura',
        'ASTM – Materiales y ensayos de laboratorio',
        'GRI, AISC, ACI – Geomembranas, acero estructural y concreto',
        'IEC / NFPA / IEEE – Instalaciones eléctricas e instrumentación',
        'Especificaciones del cliente y requerimientos del fabricante',
      ],
    },
    {
      id: 'Personal Calificado',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF4789"
    stroke="#F8CF4789"
    viewBox="0 0 95.469 95.469"  >
    <path d="M71.875 66.208h5.486v14.061h-5.486z" />
    <circle cx={74.619} cy={61.311} r={3.217} />
    <path d="M74.457 48.639c-6.041 0-11.475 2.579-15.311 6.672l-1.068-.492-4.947-4.17-8.502 8.455-8.523-8.455-4.947 4.17-10.299 4.742c-1.523.625-2.875 1.707-3.781 3.228L0 87.296l63.133.028a20.871 20.871 0 0 0 11.324 3.339c11.586 0 21.012-9.427 21.012-21.013-.001-11.585-9.426-21.011-21.012-21.011zm0 35.799c-8.154 0-14.787-6.634-14.787-14.787 0-8.152 6.633-14.785 14.787-14.785 8.152 0 14.785 6.633 14.785 14.785 0 8.153-6.633 14.787-14.785 14.787z" />
    <path d="M44.562 51.667v.003l.029-.002.02.002h.014l.02-.002.029.002v-.003c12.004.183 19.301-10.324 19.49-27.646.121-12.017-7.332-18.888-19.469-19.211v-.005l-.051.001v-.001l-.027.001-.025-.001v.001l-.049-.001v.005c-12.139.324-19.592 7.195-19.471 19.212.187 17.321 7.484 27.828 19.49 27.645z" />
  </svg>
      ),
      title: 'Personal Calificado',
      subtitle: 'Ingenieros, supervisores, inspectores, soldadores calificados, técnicos de termofusión/geomembrana, topógrafos, personal civil, eléctrico y de montaje con experiencia en proyectos industriales.',
      details: [
        'Ingenieros con experiencia en proyectos industriales de alto impacto',
        'Supervisores e inspectores de calidad certificados',
        'Soldadores calificados bajo códigos ASME y AWS',
        'Técnicos especializados en termofusión y geomembrana',
        'Topógrafos para replanteo y control geométrico',
        'Personal civil, eléctrico y de montaje multidisciplinario',
      ],
    },
    {
      id: 'Inspección, Pruebas y Trazabilidad',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    transform="scale(-1 1)"
    viewBox="0 0 482.339 482.339"  >
    <path d="M472.315 424.001 367.99 319.691c-7.495 10.312-15.836 19.474-22.352 25.987-6.5 6.521-15.66 14.84-25.974 22.336l104.318 104.311c13.337 13.352 34.979 13.352 48.312 0a34.107 34.107 0 0 0 10.013-24.172 34.144 34.144 0 0 0-9.992-24.152zM352.74 270.29l-63.982-39.766c13.05-22.953 20.12-48.945 20.12-76.059.017-41.27-16.056-80.055-45.227-109.227C234.483 16.054 195.694 0 154.44 0 113.17 0 74.381 16.055 45.198 45.238c-60.223 60.223-60.223 158.203 0 218.438 29.185 29.172 67.956 45.228 109.211 45.228 27.129 0 53.133-7.069 76.103-20.138l39.753 64c1.025 1.031 2.53 1.521 4.413 1.521 9.539 0 29.043-12.496 48.056-31.509 22.812-22.781 36.226-46.285 30.006-52.488zM79.558 229.321c-41.272-41.289-41.272-108.453 0-149.707 20.009-20.012 46.603-31.021 74.884-31.021 28.271 0 54.859 11.008 74.855 31.004 19.99 19.992 30.987 46.586 30.987 74.853 0 28.27-11.012 54.859-31.004 74.854-19.996 19.992-46.586 31.003-74.871 31.003-28.268.004-54.858-11.009-74.851-30.986z" />
  </svg>
      ),
      title: 'Inspección, Pruebas y Trazabilidad',
      subtitle: 'Recepción de materiales, inspecciones dimensionales, ensayos y pruebas, liberación de frentes, registros por sistema y dossiers de calidad.',
      details: [
        'Recepción e inspección de materiales con verificación de certificados',
        'Inspecciones dimensionales y visuales en campo',
        'Ensayos no destructivos (END): PT, MT, UT, RT',
        'Pruebas hidrostáticas y neumáticas de sistemas',
        'Liberación de frentes con registros firmados',
        'Trazabilidad por sistema y subsistema',
        'Elaboración de dossiers de calidad al cierre del proyecto',
      ],
    },
    {
      id: 'seguridad',
      icon: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 467.5 467.5"  >
    <path d="M292.4 232.528c0-3.754-3.047-6.8-6.801-6.8h-88.4a6.803 6.803 0 0 0-6.8 6.8v217.6c0 3.754 3.046 6.8 6.8 6.8h88.4a6.803 6.803 0 0 0 6.801-6.8v-217.6zm173.719-100.3L398.555 14.384c-3.236-5.61-8.541-6.032-11.777-.422l-67.551 118.483c-3.238 5.603-.586 11.682 5.889 11.682h21.686v302.601c0 3.739 4.732 10.199 8.473 10.199h74.799c3.74 0 5.127-6.46 5.127-10.199v-302.6h25.031c6.473 0 9.123-6.29 5.887-11.9zm-436.974 6.385c0-26.819 21.74-48.559 48.559-48.559s48.559 21.739 48.559 48.559-21.74 48.559-48.559 48.559c-26.82 0-48.559-21.739-48.559-48.559zm50.082 297.915c0 13.6-8.452 22.113-21.325 20.89-11.22-1.061-17.102-11.717-17.102-22.991V322.05c0 9.234-11.057 16.633-20.407 16.633C10.064 338.683 0 329.932 0 321.159v-80.043c0-20.855 15.211-35.788 36.067-35.788H52.7l27.2 47.6 27.2-47.6h16.245c20.855 0 39.854 14.933 39.854 35.795v80.043c0 8.772-10.064 17.523-20.393 17.523-9.35 0-20.407-7.398-20.407-16.633v112.377c0 11.274-7.772 21.924-18.999 22.991-12.873 1.217-23.215-7.297-23.215-20.896h-.958z" />
  </svg>
      ),
      title: 'Mejora Continua y Confianza del Cliente',
      subtitle: 'Reportes, no conformidades, acciones correctivas, seguimiento de KPIs, auditoría documental y decisiones oportunas.',
      details: [
        'Emisión y seguimiento de reportes de calidad periódicos',
        'Gestión de no conformidades (NCRs) y acciones correctivas',
        'Monitoreo de KPIs de calidad por proyecto',
        'Auditorías documentales internas y externas',
        'Toma de decisiones oportuna basada en datos',
        'Retroalimentación continua con el cliente para garantizar su confianza',
      ],
    },
  ];

  return (
    <div className="identidad-container">
      <div className="halo" ref={haloRef}></div>
      
      {/* Hero Section */}
      <section className="hero-carousel-section">
        <div className="hero-carousel-text">
          <h1 className="hero-title">
            <span className="highlight">Sistema Integral de Calidad Rêver</span>
          </h1>
          <div className="animated-underline"></div>
          <p className="hero-subtitle">
            En Rêver aplicamos la gestión de calidad en todo el ciclo de vida del proyecto,
            desde la planificación hasta el cierre, con un control técnico riguroso, trazabilidad
            completa, inspección, pruebas y mejora continua en todas nuestras especialidades.
          </p>
        </div>

        <div className="hero-carousel-media">
          <Splide options={carouselOptions} className="main-carousel">
            {mainImages.map((image, index) => (
              <SplideSlide key={index}>
                <div className="carousel-slide">
                  <img src={image.src} alt={image.alt} className="carousel-image" />
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="values-grid">
            {valuesData.map((value) => (
              <div 
                key={value.id} 
                className={`flip-card ${flippedCards[value.id] ? 'flipped' : ''}`}
              >
                <div className="flip-card-inner">
                  {/* Front Side */}
                  <div className="flip-card-front">
                    <button 
                      className="flip-button"
                      onClick={() => toggleCard(value.id)}
                      aria-label="Voltear tarjeta"
                      title="Voltear tarjeta"
                    >
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="#F8CF47"
    stroke="#F8CF47"
    viewBox="0 0 24 24"
  >
    <path d="M16.053 12.724C15.135 10.887 13.803 10 12 10c-1.804 0-3.135.887-4.053 2.724a.5.5 0 0 1-.894-.448C8.135 10.113 9.803 9 12 9c2.196 0 3.865 1.113 4.947 3.276a.5.5 0 0 1-.894.448ZM16 12V9.5a.5.5 0 1 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 1 1 0-1H16Zm2.5-9A2.5 2.5 0 0 1 21 5.5a.5.5 0 1 1-1 0A1.5 1.5 0 0 0 18.5 4a.5.5 0 1 1 0-1Zm-2 1h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1ZM21 8.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 1 1 1 0Zm0 5v2a.5.5 0 1 1-1 0v-2a.5.5 0 1 1 1 0Zm0 5a2.5 2.5 0 0 1-2.5 2.5.5.5 0 1 1 0-1 1.5 1.5 0 0 0 1.5-1.5.5.5 0 1 1 1 0ZM16.5 21h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1ZM12 2.5v4a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0Zm0 12v7a.5.5 0 1 1-1 0v-7a.5.5 0 1 1 1 0ZM8.5 4h-3A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20h3a.5.5 0 1 1 0 1h-3A2.5 2.5 0 0 1 3 18.5v-13A2.5 2.5 0 0 1 5.5 3h3a.5.5 0 0 1 0 1Z" />
  </svg>
                    </button>
                    
                    <div className="card-icon">
                      {value.icon}
                    </div>
                    <h3 className="card-title">{value.title}</h3>
                    <p className="card-subtitle">{value.subtitle}</p>
                    <p className="card-description">{value.description}</p>
                    
                    
                  </div>

                  {/* Back Side */}
                  <div className="flip-card-back">
                    <button 
                      className="flip-button"
                      onClick={() => toggleCard(value.id)}
                      aria-label="Voltear tarjeta"
                      title="Volver"
                    >
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    stroke="#F8CF47"
    viewBox="0 0 24 24"
  >
    <path
      fill="#F8CF47"
      d="m4 10-.707.707L2.586 10l.707-.707L4 10Zm17 8a1 1 0 1 1-2 0h2ZM8.293 15.707l-5-5 1.414-1.414 5 5-1.414 1.414Zm-5-6.414 5-5 1.414 1.414-5 5-1.414-1.414ZM4 9h10v2H4V9Zm17 7v2h-2v-2h2Zm-7-7a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5V9Z"
    />
  </svg>
                    </button>
      <div className="section-divider"></div>

                    <ul className="card-list">
                      {value.details.map((detail, index) => (
                        <li key={index}>{detail}</li>
                      ))}
                    </ul>
                    

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>
    </div>
  );
};

export default Identidad;